import { CardProps } from '.';

interface CardContainerProps extends CardProps {}

export default function CardContainer({
  children,
  className = '',
  ...rest
}: CardContainerProps) {
  return (
    <div className={`card-container ${className}`} {...rest}>
      {children}
    </div>
  );
}
